import { fetchData } from '..';
export async function getRemoteAppConfig(configLocation, abortController) {
    return await fetchData(configLocation, abortController);
}
